<template>
  <ClicColInterno
    :cp="cp"
    :key="componentKey"
  >
    <div class="form-group left-label" style="height: 100%;">    
      <div class="d-flex flex-row align-items-start">
        <label class="form-label form-label-clic" v-if="label">
          {{ $storage.getTextoTraduzido(label) }}
        </label>
        <ClicHintInterno
          v-if="hintText"
          :cp="cp"
        />
      </div>

      <ClicMarkdownInterno
        :cp="cp"
        :state="state"
        :key="cpId"
        v-model="text" 
        :mode="mode"
        :height="height"
        :tab-size="tabSize"
        :toc-nav-position-right="tocNavPositionRight"
        :default-show-toc="defaultShowToc"
        :placeholder="placeholder"
        :autofocus="autofocus"
        :default-fullscreen="defaultFullscreen"
        :include-level="includeLevel"
        :left-toolbar="leftToolbar" 
        :right-toolbar="rightToolbar"
        :toolbar="toolbarTratada"
        :toolbar-config="toolbarConfig"
        :disabled-menus="disabledMenus"
        :upload-image-config="uploadImageConfig" 
        :before-preview-change="beforePreviewChange"
        :codemirror-config="codemirrorConfig"
        :codemirror-style-reset="codemirrorStyleReset"
        :style-value="style"
        :editor-class="this.class"
        :idioma="idioma"
        :current-language="$storage.getIdioma()"
        @change="change"
        @blur="blur"
        @save="save"
        @image-click="imageClick"
        @fullscreen-change="fullscreenChange"
        @upload-image="uploadImage"
      />

    </div>
  </ClicColInterno>
</template>

<script>

import ComponentMixin from '../../core/ComponentMixin';

export default {
  name: 'ClicMarkdown',
  mixins: [ComponentMixin],
  components: {
    ClicMarkdownInterno: () => import(
      /* webpackChunkName: "ClicMarkdownInterno", webpackPrefetch: false */ './ClicMarkdownInterno.vue'
    )
  },

  data() {
    return {
      public : {
      },

      cpId : this.$utils.getComponentID(),
      toolbar : undefined,
      toolbarTratada : undefined,
      idioma : {
        PT : {
          undo: {
            toolbar: 'Desfazer',
          },
          redo: {
            toolbar: 'Refazer',
          },
          clear: {
            toolbar: 'Limpar',
          },
          h: {
            toolbar: 'Cabeçalhos',
          },
          h1: {
            toolbar: 'Cabeçalho 1',
            placeholder: 'Cabeçalho 1',
          },
          h2: {
            toolbar: 'Cabeçalho 2',
            placeholder: 'Cabeçalho 2',
          },
          h3: {
            toolbar: 'Cabeçalho 3',
            placeholder: 'Cabeçalho 3',
          },
          h4: {
            toolbar: 'Cabeçalho 4',
            placeholder: 'Cabeçalho 4',
          },
          h5: {
            toolbar: 'Cabeçalho 5',
            placeholder: 'Cabeçalho 5',
          },
          h6: {
            toolbar: 'Cabeçalho 6',
            placeholder: 'Cabeçalho 6',
          },
          bold: {
            toolbar: 'Negrito',
            placeholder: 'Negrito',
          },
          italic: {
            toolbar: 'Itálico',
            placeholder: 'Itálico',
          },
          strikethrough: {
            toolbar: 'Riscado',
            placeholder: 'Riscado',
          },
          quote: {
            toolbar: 'Citação',
            placeholder: 'Citação',
          },
          ul: {
            toolbar: 'Lista não ordenada',
            placeholder: 'Lista não ordenada',
          },
          ol: {
            toolbar: 'Lista ordenada',
            placeholder: 'Lista ordenada',
          },
          table: {
            toolbar: 'Tabela',
          },
          hr: {
            toolbar: 'Linha',
          },
          link: {
            toolbar: 'Link',
            descPlaceholder: 'Link',
          },
          image: {
            toolbar: 'Imagem',
          },
          imageLink: {
            toolbar: 'Link',
          },
          uploadImage: {
            toolbar: 'Upload Imagem',
          },
          code: {
            toolbar: 'Código',
          },
          save: {
            toolbar: 'Salvar',
          },
          preview: {
            enabled: 'Habilitar pré-visualização',
            disabled: 'Desabilitar  pré-visualização',
          },
          toc: {
            title: 'Navegação',
            enabled: 'Ver navegação',
            disabled: 'Esconder navegação',
          },
          syncScroll: {
            enabled: 'Habilitar scroll sincronizado',
            disabled: 'Desabilitar scroll sincronizado',
          },
          fullscreen: {
            enabled: 'Tela cheia (ESC para sair)',
            disabled: 'Sair tela cheia',
          },
        },

        EN : {
          undo: {
            toolbar: 'Undo',
          },
          redo: {
            toolbar: 'Redo',
          },
          clear: {
            toolbar: 'Clear',
          },
          h: {
            toolbar: 'Headings',
          },
          h1: {
            toolbar: 'Heading 1',
            placeholder: 'Heading 1',
          },
          h2: {
            toolbar: 'Heading 2',
            placeholder: 'Heading 2',
          },
          h3: {
            toolbar: 'Heading 3',
            placeholder: 'Heading 3',
          },
          h4: {
            toolbar: 'Heading 4',
            placeholder: 'Heading 4',
          },
          h5: {
            toolbar: 'Heading 5',
            placeholder: 'Heading 5',
          },
          h6: {
            toolbar: 'Heading 6',
            placeholder: 'Heading 6',
          },
          bold: {
            toolbar: 'Bold',
            placeholder: 'Bold',
          },
          italic: {
            toolbar: 'Italic',
            placeholder: 'Italic',
          },
          strikethrough: {
            toolbar: 'Strike',
            placeholder: 'Strike',
          },
          quote: {
            toolbar: 'Blockquote',
            placeholder: 'Blockquote',
          },
          ul: {
            toolbar: 'Unordered list',
            placeholder: 'Unordered list',
          },
          ol: {
            toolbar: 'Ordered list',
            placeholder: 'Ordered list',
          },
          table: {
            toolbar: 'Insert table',
          },
          hr: {
            toolbar: 'Line',
          },
          link: {
            toolbar: 'Insert link',
            descPlaceholder: 'Link',
          },
          image: {
            toolbar: 'Insert image',
          },
          imageLink: {
            toolbar: 'Insert link',
          },
          uploadImage: {
            toolbar: 'Upload Image',
          },
          code: {
            toolbar: 'Insert Codeblock',
          },
          save: {
            toolbar: 'Save',
          },
          preview: {
            enabled: 'Enable preview',
            disabled: 'Disable preview',
          },
          toc: {
            title: 'Navigation',
            enabled: 'Enable navigation',
            disabled: 'Disable navigation',
          },
          syncScroll: {
            enabled: 'Enable sync scroll ',
            disabled: 'Disable sync scroll',
          },
          fullscreen: {
            enabled: 'Full screen(Press ESC to exit)',
            disabled: 'Exit Full Screen',
          },
        }
      }
    }
  },

  watch: {
    toolbar(toolbar) {
      try {
        let objConvertido = new Function(`return ${toolbar}`).bind(this)();

        for (let key in objConvertido) {
          const item = objConvertido[key];
  
          if  (item.script) {
            item.action = (editor) => {
              editor.insert((selected) => {
                try {
                  return new Function(`${item.script}`).bind(this)();
                }catch (e) {
                  console.error(`[ClicMarkdown] Falha ao criar script do item '${item.title}''. Detalhes: ${e}`);
                }
              });
            }

          } else if (!item.action) {
            item.action = (editor) => {
              editor.insert((selected) => {
                return {
                  text: "(((nao implementado)))",
                  selected: "",
                };
              });
            }
          }

        }
        this.toolbarTratada = objConvertido;
        this.cpId = this.$utils.getComponentID();
      } catch (e) {
        console.error(`[ClicMarkdown] Falha ao converter prop 'toolbar' para json. Detalhes: ${e}`);
      }
    },  
  },

  methods: {

    kebabToCamelCase(str) {
      const camelCaseStr = str.replace(/-./g, match => match.charAt(1).toUpperCase());
      return camelCaseStr.charAt(0).toUpperCase() + camelCaseStr.slice(1);
    },

    change(text, html) {
      if(this.lodash.has(this.cp, 'events.change')){
        this._execEvent('change', { text, html });
      }
    },

    blur(event) {
      if(this.lodash.has(this.cp, 'events.blur')){
        this._execEvent('blur', { event });
      }
    },

    save(text, html) {
      if(this.lodash.has(this.cp, 'events.save')){
        this._execEvent('save', { text, html });
      }
    },

    imageClick(images, currentIndex) {
      if(this.lodash.has(this.cp, 'events.imageClick')){
        this._execEvent('imageClick', { images, currentIndex });
      }
    },

    fullscreenChange(isFullscreen) {
      if(this.lodash.has(this.cp, 'events.fullscreenChange')){
        this._execEvent('fullscreenChange', { isFullscreen });
      }
    },

    uploadImage(event, insertImage) {
      if(this.lodash.has(this.cp, 'events.uploadImage')){
        this._execEvent('uploadImage', { event, insertImage });
      }
    },
    
  }
};
</script>

<style lang="scss" rel="stylesheet/less" scoped>

  .clicMarkdown {
    width: 100%;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

</style>
